import { useSelector } from 'react-redux'
import { selectCurrentMerchant } from 'selectors/merchant'

// Matches the nexus default. Used until the API sends the merchant's limit.
export const DEFAULT_CUSTOMER_IMPORT_ROW_LIMIT = 100000

const useCustomerImportRowLimit = (): number => {
  const merchant = useSelector(selectCurrentMerchant)
  return merchant.customer_import_row_limit ?? DEFAULT_CUSTOMER_IMPORT_ROW_LIMIT
}

export default useCustomerImportRowLimit
